import React from 'react';
import EmailPhoneInputField from 'components/EmailPhoneInputField';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import validations from 'validations';

type EmailOrPhoneFieldWrapperProps = {
  className?: string;
  required?: boolean;
  readOnly?: boolean;
};

const EmailOrPhoneFieldWrapper: React.FC<EmailOrPhoneFieldWrapperProps> = (
  props,
) => {
  const { required = true, readOnly = false } = props;

  const { t } = useTranslation();

  return (
    <Field
      name="emailOrPhone"
      component={EmailPhoneInputField}
      label={t('emailOrPhone')}
      description={t('emailOrPhoneFieldDescription')}
      required={required}
      readOnly={readOnly}
      validate={validations.composeValidators(
        required ? validations.required() : null,
        validations.emailOrPhoneValidation(),
      )}
    />
  );
};

export default EmailOrPhoneFieldWrapper;
